import { Auth } from "aws-amplify";
import { preForgotPasswordHook } from 'amplify/services';

const REMEMBER_DEVICE_KEY = "rememberDevice";

// Idea behind this hook is to allow API know user is trying to reset password
// In case user hasn't ever changed initial temp password (or this password has expired),
// by default he is not able to resolve issue on his own by using change password and is
// expected to involve administrator for resoution.
// Instead we hook into forgot password process and in case we see user hasn't changed
// initial password yet, API changes his state so that it allows user to invoke change
// password

// In case user is initally ok, prehook does nothing
const services = {
  async handleForgotPassword(email) {
    return preForgotPasswordHook(email)
      .finally(() => Auth.forgotPassword(email));
  },

  async handleConfirmSignIn({ code, mfaType, user }) {
    await Auth.confirmSignIn(user, code, mfaType);
    // If "remember device" is checked, remember device with Cognito
    const rememberDevice = sessionStorage.getItem(REMEMBER_DEVICE_KEY) === 'true';
    if (rememberDevice) {
      try {
        const deviceKey = user?.deviceKey;
        // @to-do persist on backend as well for further expiration
        console.log('Device remembered successfully:', {
          deviceKey,
        });

        await Auth.rememberDevice();

        console.log('Device remembered successfully:', {
          deviceKey,
        });

      } catch (apiError) {
        console.error('Remember device failed:', apiError);
        // Clear the state in case of error
        sessionStorage.removeItem(REMEMBER_DEVICE_KEY);
      }
    }

    // Clear the state after use
    sessionStorage.removeItem(REMEMBER_DEVICE_KEY);

    return user;
  }
};

export default services;
